var React = require('react');

function ClearLuckyNumber (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"b"},React.createElement("rect",{"width":"32","height":"32"}))),React.createElement("g",{"id":"a","clipPath":"url(#b)","key":1},React.createElement("path",{"d":"M14,6.667A5.333,5.333,0,0,1,8.667,12h-1.6l1.582-1.519a.667.667,0,1,0-.923-.962L4.945,12.186a.667.667,0,0,0,0,.962l2.778,2.667a.667.667,0,1,0,.923-.962L7.064,13.333h1.6A6.667,6.667,0,1,0,2,6.667V7A.667.667,0,0,0,3.333,7V6.667A5.333,5.333,0,1,1,14,6.667Z","transform":"translate(7 8)","fill":"#2425aa","fillRule":"evenodd"}))]);
}

ClearLuckyNumber.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ClearLuckyNumber;

ClearLuckyNumber.default = ClearLuckyNumber;
